import React, { useEffect, useRef } from 'react';

import useGlobalState from '../../GlobalStateContext';

import LeftSidebarCategory from './LeftSidebarCategory';
import {
    getAdministratorsCategory,
    getAffilatesCategory,
    getAgentsCategory,
    getBlockedCountriesCategory,
    getCasinoContentCategory,
    getCasinoReportsCategory,
    getContentCategory,
    getDashboardCategory,
    getLogoutItem,
    getLootboxCategory,
    getLotteriesCategory,
    getPaymentsCategory,
    getProfileCategory,
    getPromocodesCategory,
    getTicketsCategory,
    getUsersCategory,
    getVouchersCategory,
    getWithdrawalsCategory,
} from './SidebarCategories';
import { SidebarCategory } from './SidebarCategoryTypes';

interface Props {
    setTopLogoVisible: (visible: boolean) => void;
}

const LeftSidebar = ({ setTopLogoVisible }: Props) => {
    const { loggedAdmin } = useGlobalState();
    const asideElement = useRef<HTMLDivElement>(null);

    const sidebarCategories: SidebarCategory[] = [
        getDashboardCategory(loggedAdmin),
        getUsersCategory(loggedAdmin),
        getTicketsCategory(loggedAdmin),
        getLootboxCategory(loggedAdmin),
        getCasinoReportsCategory(loggedAdmin),
        getPaymentsCategory(loggedAdmin),
        getWithdrawalsCategory(loggedAdmin),
        getAffilatesCategory(loggedAdmin),
        getAgentsCategory(loggedAdmin),
        getVouchersCategory(loggedAdmin),
        getPromocodesCategory(loggedAdmin),
        getContentCategory(loggedAdmin),
        getCasinoContentCategory(loggedAdmin),
        getLotteriesCategory(loggedAdmin),
        getBlockedCountriesCategory(loggedAdmin),
        getAdministratorsCategory(loggedAdmin),
        getProfileCategory(),
        getLogoutItem(),
    ].filter((category) => category.items && category.items.length > 0);

    useEffect(() => {
        const savedScrollPosition = sessionStorage.getItem('sidebarScrollPosition');
        if (savedScrollPosition && asideElement.current) {
            asideElement.current.scrollTop = parseInt(savedScrollPosition, 10);
        }

        const handleScroll = () => {
            if (asideElement.current) {
                sessionStorage.setItem('sidebarScrollPosition', asideElement.current.scrollTop.toString());
            }
        };

        if (asideElement.current) {
            asideElement.current.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (asideElement.current) {
                asideElement.current.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    return (
        <aside
            ref={asideElement}
            className="left-sidebar"
            data-sidebarbg="skin5"
            onMouseEnter={() => setTopLogoVisible(true)}
            onMouseLeave={() => setTopLogoVisible(false)}
        >
            <div className="scroll-sidebar">
                <nav className="sidebar-nav">
                    <ul id="sidebarnav">
                        {sidebarCategories.map((category, index) => (
                            <LeftSidebarCategory
                                category={category}
                                key={category.name ?? `sidebar-category-${index}`}
                            />
                        ))}
                    </ul>
                </nav>
            </div>
        </aside>
    );
};

export default LeftSidebar;
